/**
 * ContentArea — main content region with optional top-bar header slot.
 * Feature-agnostic: the caller injects header content via the slot prop.
 */

import React from 'react';

export interface ContentAreaProps {
  children: React.ReactNode;
  headerSlot?: React.ReactNode;
  leadingSlot?: React.ReactNode;
}

export function ContentArea({ children, headerSlot, leadingSlot }: ContentAreaProps) {
  const hasTopBar = Boolean(headerSlot) || Boolean(leadingSlot);
  return (
    <div className="content-area-wrapper">
      {hasTopBar && (
        <header className="top-bar" data-testid="top-bar">
          {leadingSlot}
          <div className="top-bar-spacer" />
          {headerSlot}
        </header>
      )}
      <main className="content-area" role="main">
        {children}
      </main>
    </div>
  );
}
